<template>
  <div class="container applications">
    <Loader v-if="!loaded" :isLoading="true"></Loader>
    <template v-else>
      <div class="main-container-header">
        <div class="main-container-header__title">
          <img
              height="32"
              width="32"
              :src="require('@/assets/images/icon-api-gray.svg')"
          />
          <h2>Applications</h2>
        </div>
      </div>
      <div class="main-container-body">
        <div v-if="!applications.length">
          No applications to display
        </div>
        <div v-else>
          <div class="panel panel-primary" v-for="application in applications" :key="application.id">
            <div class="panel-body">
              <h3 class="mt-0">{{ application.data.label }}</h3>
              <div class="row">
                <div class="col-2" v-if="application.data.image_url">
                  <img :src="application.data.image_url"
                       class="application-logo"
                  >
                </div>
                <div :class="{
                  'col-8': !application.data.image_url,
                  'col-6': application.data.image_url
                }">
                  <p>{{ application.data.description }}</p>
                  <p>Website: <a :href="application.data.url">{{ application.data.url }}</a></p>
                  <div>
                    Details:<br>
                    <ul>
                      <li v-if="application.data.enable_ndc">
                        <b>NDC API access with permissions</b> <br>
                        <ul>
                          <li v-for="perm in getPermissionsText(application)">{{ perm }}</li>
                        </ul>
                      </li>
                      <li v-if="application.data.webhook_url">
                        <b>Application will receive NDC events:</b>
                        <ul>
                          <li v-for="ev in getEventsText(application)">{{ev}}</li>
                        </ul>
                      </li>
                      <li v-if="getHubPermissionsText(application).length">
                        <b>Hub API:</b>
                        <ul>
                          <li v-if="application.data.hub_direct_access">Hub Management direct access</li>
                          <li v-for="perm in getHubPermissionsText(application)">{{ perm }}</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div v-if="application.data.ndc_token || application.data.hub_token">
                    Access Tokens:
                    <ul>
                      <li v-if="application.data.ndc_token">NDC <b>{{ application.data.ndc_token }}</b></li>
                      <li v-if="application.data.hub_token">Hub <b>{{ application.data.hub_token }}</b></li>
                    </ul>
                  </div>
                </div>
                <div class="col-4 text-right">
                  <span
                      v-if="isSuperagency()"
                      @click="selectedApplication = application; showApplicationModal()"
                      class="btn btn-primary-outline"
                  >{{ application.enabled ? 'Revoke' : 'Activate' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <b-modal
        @hidden="onModalHidden"
        title="Confirmation"
        ref="toggleStatusModal"
        size="md"
    >
      <div class="row">
        <div class="col">
          <div class="d-block">
            <p class="description">{{ alertMessage }}</p>
          </div>
        </div>
      </div>
      <div slot="modal-footer" class="">
        <button
            @click="hideApplicationModal()"
            class="btn mr-3"
        >Cancel
        </button>
        <button
            @click="toggleApplicationStatus(selectedApplication)"
            class="btn btn-primary"
        >{{ selectedApplication.enabled ? 'Revoke' : 'Activate' }}
        </button>
      </div>
    </b-modal>

  </div>
</template>

<script>
import axios from '@/services/axios';
import NavigationBar from './shared/+navigation-bar'
import Loader from './shared/+loader'
import helpers from "../mixins/helpers";

export default {
  components: {
    NavigationBar,
    Loader,
  },
  data() {
    return {
      loaded: false,
      submitted: false,
      applications: [],
      selectedApplication: {data: {}},
      resultType: '',
      form: {},
      error: '',
    }
  },
  mounted: function () {
    this.init();
  },
  mixins: [
    helpers,
  ],
  methods: {
    init() {
      let p1 = axios.get("/agent/access/application/list")
          .then(res => {
            this.applications = res.data;
          })
          .catch();

      Promise.all([p1]).then(() => {
        setTimeout(() => {
          this.loaded = true
        }, 200);
      });

    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    showApplicationModal() {
      this.$refs.toggleStatusModal.show();
    },
    hideApplicationModal() {
      this.$refs.toggleStatusModal.hide();
    },
    getPermissionsText(application) {
      if (application.data.enable_ndc) {
        let permissions = [];
        Object.entries(application.data.permissions).map(v => {
          if (v[1]) {
            permissions.push(this.capitalizeFirstLetter(v[0]).replace(/_/ig, ' '))
          }
        })
        return permissions
      }
      return []
    },
    getEventsText(application) {
      if (application.data.webhook_url) {
        let items = [];
        Object.entries(application.data.webhook_events).map(v => {
          if (v[1]) {
            items.push(this.capitalizeFirstLetter(v[0]).replace(/_/ig, ' '))
          }
        })
        return items
      }
      return []
    },
    getHubPermissionsText(application) {
      let items = [
        'hub_allowance_app_agent_management',
        'hub_allowance_app_authentication',
        'hub_allowance_app_subagency_management',
        'hub_allowance_corporate_portal_authentication',
        'hub_allowance_corporate_portal_corporate_management'
      ]
      let permissions = [];
      items.map(item => {
        if (application.data[item]) {
          permissions.push(this.capitalizeFirstLetter(item.replace('hub_allowance_', '')).replace(/_/ig, ' '))
        }
      })
      return permissions
    },
    onModalHidden() {
    },
    toggleApplicationStatus(application) {
      axios.post("/agent/access/application/update", {
        id: application.data.id,
        status: application.enabled ? 'disable' : 'enable'
      }).then(() => {
        this.init();
        this.hideApplicationModal();
      });
    },
  },
  computed: {
    alertMessage() {
      if (!this.selectedApplication.enabled) {
        return 'By activating this application you are granting them access to you airline content for shopping, booking and issuing orders. This can be revoked anytime. Are you sure you want to do this?'
      } else {
        return 'By revoking this, the application won’t be able to access your airline content anymore. Are you sure you want to do this?'
      }
    },
  }
};
</script>

<style lang="scss">
.description {
  font-size: 1.2rem;
}

.applications {
  .panel {
    margin-bottom: 2rem !important;
  }

  .panel-body {
    padding: 2rem;
  }

  .table {
    border: 1px solid #ececec;

    td,
    th {
      padding: 0.75rem 1.5rem;
    }

    tbody {
      tr {
        &:hover {
          background-color: #f7fbff;
        }
      }
    }

    thead {
      tr {
        background-color: #f2f4f7;
      }

      th {
        color: #606060;
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.04rem;
      }
    }

    td {
      border-bottom: 0;
      border-bottom: 1px solid #ececec;
      vertical-align: middle;

      button {
        font-size: 12px;
      }
    }

  }

  .agentStatus {
    font-size: 13px;
    text-transform: uppercase;
    font-weight: 800;
    letter-spacing: 0.05rem;
  }

  .application-logo {
    max-width: 150px;
    max-height: 150px;
    display: block;
  }
}

</style>
